module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "wdqb-box"
  }, [_c('div', {
    staticClass: "wdqb-content"
  }, [_c('div', {
    staticClass: "wdqb-left"
  }, [_c('div', {
    staticClass: "wdqb-coin-card"
  }, [_c('img', {
    staticClass: "wdqb-coin-icon",
    attrs: {
      "src": _vm.data.currencyLogo,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wdqb-coin-info"
  }, [_c('span', {
    staticClass: "wdqb-coin-name"
  }, [_vm._v(_vm._s(_vm.data.unitText))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-coin-desc"
  }, [_vm._v(_vm._s(_vm.$t('all.lianshangbaobishibei')))])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-item"
  }, [_c('span', {
    staticClass: "wdqb-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.zonge')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-item-value"
  }, [_vm._v(_vm._s(_vm.data.sumAmount) + " " + _vm._s(_vm.data.unitText))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-item"
  }, [_c('span', {
    staticClass: "wdqb-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.keyongshuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-item-value"
  }, [_vm._v(_vm._s(_vm.data.sumAvailableAmount) + " " + _vm._s(_vm.data.unitText))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-item"
  }, [_c('span', {
    staticClass: "wdqb-item-label"
  }, [_vm._v(_vm._s(_vm.$t('all.dongjieshuliang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-item-value"
  }, [_vm._v(_vm._s(_vm.data.sumFreezeAmount) + " " + _vm._s(_vm.data.unitText))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-actions"
  }, [_c('div', {
    class: _vm.activeTab === 'deposit' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn',
    on: {
      "click": function($event) {
        _vm.activeTab = 'deposit'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chongbi')))]), _vm._v(" "), _c('div', {
    class: _vm.activeTab === 'withdraw' ? 'wdqb-action-btn wdqb-action-gradient' : 'wdqb-action-btn',
    on: {
      "click": function($event) {
        _vm.activeTab = 'withdraw'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tibi')))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-flow-btn",
    on: {
      "click": _vm.handleGoFlow
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chakanliushui')))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right"
  }, [(_vm.activeTab === 'deposit') ? [_c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.dizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item-right"
  }, [_c('span', {
    staticClass: "wdqb-right-value wdqb-text-green"
  }, [_vm._v(_vm._s(_vm.formatAddress(_vm.data.rechargeAddress)))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/image/fuzhi_18@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.handleCopyAddress
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-right-value wdqb-text-green"
  }, [_vm._v(_vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-tip"
  }, [_vm._v(_vm._s(_vm.$t('all.chongzhitip')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.chongzhishuliang')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depositAmount),
      expression: "depositAmount"
    }],
    staticClass: "wdqb-right-input",
    attrs: {
      "placeholder": _vm.$t('all.shuru')
    },
    domProps: {
      "value": (_vm.depositAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.depositAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate"
  }, [_c('span', {
    staticClass: "wdqb-right-estimate-title"
  }, [_vm._v(_vm._s(_vm.$t('all.yujidaozhang')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate-card"
  }, [_c('span', {
    staticClass: "wdqb-right-estimate-label"
  }, [_vm._v(_vm._s(_vm.$t('all.shijidaozhang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-right-estimate-num"
  }, [_vm._v("99.00 NB")])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.chongzhishuliang')) + " 100.00 NB")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.shouxufei')) + " 1.00 NB (1%)")])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-btn",
    on: {
      "click": _vm.handleRecharge
    }
  }, [_vm._v(_vm._s(_vm.$t('all.lijichongzhi')))])] : _vm._e(), _vm._v(" "), (_vm.activeTab === 'withdraw') ? [_c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tibidizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item-right"
  }, [_c('span', {
    staticClass: "wdqb-right-value wdqb-text-green"
  }, [_vm._v(_vm._s(_vm.formatAddress(_vm.data.rechargeAddress)))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/image/jinru_14@2x.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.wangluo')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-right-value"
  }, [_vm._v(_vm._s(_vm.data.currencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-item"
  }, [_c('span', {
    staticClass: "wdqb-right-label"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishuliang')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.withdrawAmount),
      expression: "withdrawAmount"
    }],
    staticClass: "wdqb-right-input",
    attrs: {
      "placeholder": _vm.$t('all.qingshuru')
    },
    domProps: {
      "value": (_vm.withdrawAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.withdrawAmount = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.withdrawError) ? _c('div', {
    staticClass: "wdqb-right-error"
  }, [_vm._v(_vm._s(_vm.withdrawError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate"
  }, [_c('div', {
    staticClass: "wdqb-right-estimate-header"
  }, [_c('span', {
    staticClass: "wdqb-right-estimate-title"
  }, [_vm._v(_vm._s(_vm.$t('all.tibishisuan')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-right-estimate-tag"
  }, [_vm._v(_vm._s(_vm.$t('all.shouxufeibilv')) + _vm._s(_vm.data.withdrawalServiceChargeRatio))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shouxufei')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.withdrawFee) + " " + _vm._s(_vm.data.unitText))])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-estimate-row"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('all.shijidaozhang')))]), _vm._v(" "), _c('span', {
    staticClass: "wdqb-text-green"
  }, [_vm._v(_vm._s(_vm.withdrawActual) + " " + _vm._s(_vm.data.unitText))])])]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-right-btn",
    on: {
      "click": _vm.handleWithdraw
    }
  }, [_vm._v(_vm._s(_vm.$t('all.tijiaotibi')))])] : _vm._e()], 2)]), _vm._v(" "), (_vm.showAddressModal) ? _c('div', {
    staticClass: "wdqb-overlay",
    on: {
      "click": function($event) {
        _vm.showAddressModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAddressModal) ? _c('div', {
    staticClass: "wdqb-address-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "wdqb-address-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzetibidizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-address-search"
  }, [_c('img', {
    staticClass: "wdqb-address-search-icon",
    attrs: {
      "src": require("../../../assets/image/sousuo_18@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchAddress),
      expression: "searchAddress"
    }],
    staticClass: "wdqb-address-search-input",
    attrs: {
      "placeholder": _vm.$t('all.sousuodizhi')
    },
    domProps: {
      "value": (_vm.searchAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wdqb-address-list"
  }, _vm._l((_vm.addressList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "wdqb-address-item"
    }, [_c('div', {
      staticClass: "wdqb-address-item-info"
    }, [_c('span', {
      staticClass: "wdqb-address-item-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "wdqb-address-item-value"
    }, [_vm._v(_vm._s(item.address))])]), _vm._v(" "), _c('div', {
      staticClass: "wdqb-address-item-btn",
      on: {
        "click": function($event) {
          return _vm.handleSelectAddress(item)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('all.xuanze')))])])
  }), 0)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ae76454"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/wodequanbao/wodequanbao.vue
// module id = 973
// module chunks = 1